import { endpoints } from 'constants/endpoints'
import api from 'services/api'

import { toResponseIncotermData } from './adapters'
import type { ResponseIncotermData, ResponseIncotermDataApi } from './types'

export const getIncoterm = async (): Promise<ResponseIncotermData> => {
  const response = await api.get<ResponseIncotermDataApi>(endpoints.orderDraft.getIncoterm)

  return toResponseIncotermData(response.data)
}
